import React,{Component} from 'react'
import DateTime from 'react-datetime';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import Overlay from '../../../../presentation/Overlay';
import Comparison from '../../../../prototypes/Comparison';
import { ProgramTabContainer, ProgramTabPanel, ProgramTabPanelItem } from '../../../../presentation/ProgramTabContainer';
import EtelAPI from '../../../../api/EtelAPI.js';
import moment from 'moment';
import './css/DipServiceDialog.css';

import ReactGrid, {
  ReactGridHeader,
  ReactGridColumn,
  ReactGridBody,
  ReactGridReadOnlyCell,
  ReactGridIconCell,
  ReactGridRowTemplate,
  ReactGridNoRowsTemplate,
} from '../../../../presentation/ReactGrid';

class DipServicesAlertsGrid extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      row: props.row === undefined ? [] : props.row,
      alerts: props.alerts === undefined ? [] : props.alerts
    };

    this.onIconClicked = this.onIconClicked.bind( this );
  };

  static getDerivedStateFromProps( props, state ) {
    return { 
      row: props.row,
      alerts: props.alerts
    }
  }

  onIconClicked( args ) {
    if( args.iconKey === 'edit' ) {
      if( this.props.onEditRow !== undefined ) {
        this.props.onEditRow( args.row );
      }
    } else if( args.iconKey === 'delete' ) {
      this.props.onDeleteRow( args.row );
    }
  }

  onRenderHeaders() { 
    let columns = [];
    columns.push( 
      <ReactGridColumn 
        tagName="column" 
        key='EDIT'
        caption='Edit'
        width="100px"
        datatype='string' 
      />
    );
    columns.push( 
      <ReactGridColumn 
        tagName="column" 
        key='ALERT_KEY'
        caption='Alert Key'
        width="100px"
        datatype='string' 
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='ALERT_VALUE'
        caption='Alert Value'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='TIMEFRAME_MINUTES'
        caption='Time Frame'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='OCCURANCE_COUNT'
        caption='Occurances'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='LAST_OCCURANCE'
        caption='Last Occurance'
        width="200px"
        datatype='datetime'
        format="datetime"
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='ALERT_AFTER_COUNT'
        caption='Alert After'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='INACTIVE_AFTER_COUNT'
        caption='Inactive After'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='REACTIVE_AFTER_MINUTES'
        caption='Reactivate After'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='REACTIVE_AT'
        caption='Reactivate At'
        width="125px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='ACTIVE'
        caption='Active'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key='DELETE'
        caption='Del'
        width="100px"
        datatype='string'
      />
    );
    columns.push(
      <ReactGridColumn 
        tagName="column" 
        key=''
        caption=''
        width="auto"
        datatype='string'
      />
    );
    return columns;
  }

  onRenderTemplateRow() {
    return (
      <ReactGridRowTemplate tagName="rowTemplate">
        <ReactGridIconCell                                    
                tagName='iconCell'
                key="EDIT"
                column="Edit"
                width="100px"
                align="center"
                icon="icon-fontello-pencil"
                iconKey="edit"
              />                      
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="ALERT_KEY"
                column="ALERT_KEY"
                width="100px"
                align="center"
              />
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="ALERT_VALUE"
                column="ALERT_VALUE"
                width="100px"
                align="right"
              />        
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="TIMEFRAME_MINUTES"
                column="TIMEFRAME_MINUTES"
                width="100px"
                align="right"
              />        
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="OCCURANCE_COUNT"
                column="OCCURANCE_COUNT"
                width="100px"
                align="right"
              />        
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="LAST_OCCURANCE"
                column="LAST_OCCURANCE"
                width="200px"
                align="center"
                format="datetime"
              />        
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="ALERT_AFTER_COUNT"
                column="ALERT_AFTER_COUNT"
                width="100px"
                align="right"
              />        
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="INACTIVE_AFTER_COUNT"
                column="INACTIVE_AFTER_COUNT"
                width="100px"
                align="right"
              />        
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="REACTIVE_AFTER_MINUTES"
                column="REACTIVE_AFTER_MINUTES"
                width="100px"
                align="center"
                format="datetime"
              />                      
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="REACTIVE_AT"
                column="REACTIVE_AT"
                width="125px"
                align="center"
              />                      
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key="ACTIVE_TEXT"
                column="ACTIVE_TEXT"
                width="100px"
                align="center"
              />
        <ReactGridIconCell                                    
                tagName='iconCell'
                key="DELETE"
                column="Delete"
                width="100px"
                align="center"
                icon="icon-fontello-trash-8"
                iconKey="delete"
              />                      
        <ReactGridReadOnlyCell 
                tagName='readOnlyCell'
                key=""
                column=""
                width="auto"
                align="center"
              />
      </ReactGridRowTemplate>
    );
  }

  onRenderTemplateNoRow( ) {
    return (
      <ReactGridNoRowsTemplate tagName="noRowTemplate">
        <span>No Dip Service Alerts</span>
      </ReactGridNoRowsTemplate>
    );
  }

  render( ) {
    return (
      <ReactGrid 
        dataSource={this.state.alerts} 
        paging={false} 
        pageIndex={0} 
        pageSize={this.state.alerts.length}
        onIconClicked={this.onIconClicked}>
        <ReactGridHeader tagName="header">
          {this.onRenderHeaders()}
        </ReactGridHeader>
        <ReactGridBody tagName="body">
          {this.onRenderTemplateRow()}
          {this.onRenderTemplateNoRow()}
        </ReactGridBody>
      </ReactGrid>
    );
  }  
}

class DipServiceAlertForm extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      row: props.row === undefined ? [] : props.row,
      mode: props.mode === undefined ? 'NEW' : props.mode
    }

    this.onChange = this.onChange.bind( this );
  };

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;

    if( props.row !== undefined ) {
      const compare = new Comparison( props.row,state.row);
      if( compare.isMatch( compare.MatchTypes.DataRow ) === false ) {
        newState.row = props.row;
        stateChanged = true;
      }
    }

    if( props.mode !== undefined ) {
      const compare = new Comparison( props.mode,state.mode);
      if( compare.isMatch( compare.MatchTypes.String ) === false ) {
        newState.mode = props.mode;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  onChange( e ) {
    let row = this.state.row;
    let column = e.target.id;

    if( column === 'ACTIVE' ) {
      row[ column ] = e.target.checked === true ? 1 : 0;
    } else {
      row[ column ] = e.target.value;
    }
    
    if( this.props.onChangeRow !== undefined ) {
      this.props.onChangeRow( row );
    }
  }

  render( ) {
    let checked = this.state.row.ACTIVE === 0 ? false : true;
    let lastOccuranceLabel = '';
    let lastOccuranceValue = '';
    if( this.state.mode === 'EDIT' ) {
      lastOccuranceLabel = 'Last Occurance';
      lastOccuranceValue = moment(this.state.row.LAST_OCCURANCE).format('YYYY-MM-DD HH:mm:ss');
    }
    let reactiveAt = 'NEVER';
    let reactiveAtLabel = parseInt( this.state.row.ACTIVE, 10 ) === 0 ? 'Reactivate At' : '';
    let reactiveAtInput = parseInt( this.state.row.ACTIVE, 10 ) === 0 ? 
    (
      <DateTime 
      id="REACTIVE_AT"
      value={reactiveAt} 
      defaultValue={reactiveAt}
      viewDate={reactiveAt}
      dateFormat="YYYY-MM-DD"
      timeFormat="HH:mm:ss"
      width="100%" 
      tabIndex="1"
      onChange={this.onChangeReactiveAt}
      disableCloseOnClickOutside={false}
    />
    ) : (<span></span>);
    if( this.state.mode === 'EDIT' ) {
      if( this.state.REACTIVE_AT !== undefined ) {
        reactiveAt = moment(this.state.row.REACTIVE_AT).format('YYYY-MM-DD HH:mm:ss');
      }
    } else if( this.state.mode === 'NEW' ) {
      reactiveAt = moment().format('YYYY-MM-DD HH:mm:ss');
    }

    return (
      <div className="dip-services-alerts-form-entry">
        <span className="dip-services-alerts-form-entry-row1-cell1">
          &nbsp;
        </span>
        <span className="dip-services-alerts-form-entry-row1-cell2">
          <input id="ACTIVE" type="checkbox" checked={checked} onChange={this.onChange} tabIndex="0" />
          <span>Active</span>
        </span>
        <span className="dip-services-alerts-form-entry-row1-cell3">
          {reactiveAtLabel}
        </span>
        <span className="dip-services-alerts-form-entry-row1-cell4">
          {reactiveAtInput}
        </span>
        <span className="dip-services-alerts-form-entry-row1-cell5">
          &nbsp;
        </span>
        <span className="dip-services-alerts-form-entry-row1-cell6">
          &nbsp;
        </span>

        <span className="dip-services-alerts-form-entry-row2-cell1">
          Alert Key
        </span>
        <span className="dip-services-alerts-form-entry-row2-cell2">
          <input id="ALERT_KEY" type="text" value={this.state.row.ALERT_KEY} onChange={this.onChange} tabIndex="2" />
        </span>
        <span className="dip-services-alerts-form-entry-row2-cell3">
          Timeframe Minute(s)
        </span>
        <span className="dip-services-alerts-form-entry-row2-cell4">
          <input id="TIMEFRAME_MINUTES" type="text" value={this.state.row.TIMEFRAME_MINUTES} onChange={this.onChange} />
        </span>
        <span className="dip-services-alerts-form-entry-row2-cell5">
          Alert After Count
        </span>
        <span className="dip-services-alerts-form-entry-row2-cell6">
          <input id="ALERT_AFTER_COUNT" type="text" value={this.state.row.ALERT_AFTER_COUNT} onChange={this.onChange} />
        </span>

        <span className="dip-services-alerts-form-entry-row3-cell1">
          Alert Value
        </span>
        <span className="dip-services-alerts-form-entry-row3-cell2">
          <input id="ALERT_VALUE" type="text" value={this.state.row.ALERT_VALUE} onChange={this.onChange} />
        </span>
        <span className="dip-services-alerts-form-entry-row3-cell3">
          Occurance Count
        </span>
        <span className="dip-services-alerts-form-entry-row3-cell4">
          <input id="OCCURANCE_COUNT" type="text" value={this.state.row.OCCURANCE_COUNT} onChange={this.onChange} />
        </span>
        <span className="dip-services-alerts-form-entry-row3-cell5">
          Inactive After Count
        </span>
        <span className="dip-services-alerts-form-entry-row3-cell6">
          <input id="INACTIVE_AFTER_COUNT" type="text" value={this.state.row.INACTIVE_AFTER_COUNT} onChange={this.onChange} />
        </span>

        <span className="dip-services-alerts-form-entry-row4-cell1">
          &nbsp;
        </span>
        <span className="dip-services-alerts-form-entry-row4-cell2">
          &nbsp;
        </span>
        <span className="dip-services-alerts-form-entry-row4-cell3">
          {lastOccuranceLabel}
        </span>
        <span className="dip-services-alerts-form-entry-row4-cell4">
          {lastOccuranceValue}
        </span>
        <span className="dip-services-alerts-form-entry-row4-cell5">
          Reactivate After Minute(s)
        </span>
        <span className="dip-services-alerts-form-entry-row4-cell6">
          <input id="REACTIVE_AFTER_MINUTES" type="text" value={this.state.row.REACTIVE_AFTER_MINUTES} onChange={this.onChange} />
        </span>
      </div>
    );
  }
}

class DipServiceDialog extends Component {
  constructor( props ) {
    super( props );
    this.state = {
      mode: props.editMode === undefined ? 'EDIT' : props.editMode,
      row: props.row === undefined ? {} : props.row,
      childrow: props.childrow === undefined ? {} : props.childrow,
      show: props.show === undefined ? false : this.props.show,
      activeKey: 0,
      alerts: [],
      alert: {},
      alertMode: 'LIST',
      pageSize: 25,
      pageIndex: 0,
      showDeleteAlertDialog: false
    };
    this.onSelectTab = this.onSelectTab.bind( this );
    this.onClose = this.onClose.bind( this );
    this.onSave = this.onSave.bind( this );
    this.onChangeRow = this.onChangeRow.bind( this );
    this.onChangeReactiveAt = this.onChangeReactiveAt.bind( this );
    
    this.getAlerts = this.getAlerts.bind( this );
    this.onEditAlertRow = this.onEditAlertRow.bind( this );
    this.onDeleteAlertRow = this.onDeleteAlertRow.bind( this );
    this.onDeleteAlertCancel = this.onDeleteAlertCancel.bind( this );
    this.onDeleteAlertConfirm = this.onDeleteAlertConfirm.bind( this );
    this.onChangeAlertRow = this.onChangeAlertRow.bind( this );
    this.onNewAlertInput = this.onNewAlertInput.bind( this );
    this.onCancelAlertInput = this.onCancelAlertInput.bind( this );
    this.onSaveAlertInput = this.onSaveAlertInput.bind( this );
    
  };

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;

    if( props.show !== undefined ) {
      const compare = new Comparison(props.show, state.show);
      if( compare.isMatch( compare.MatchTypes.Boolean ) === false ) {
        newState.show = props.show
        stateChanged = true
      }
    }

    if( props.mode !== undefined ) {
      const compare = new Comparison(props.mode, state.mode);
      if( compare.isMatch( compare.MatchTypes.String ) === false ) {
        newState.mode = props.mode
        stateChanged = true
      }
    }

    if( props.activeKey !== undefined ) {
      const compare = new Comparison( props.activeKey, state.activeKey );
      if( compare.isMatch( compare.MatchTypes.Integer ) === false ) {
        newState.activeKey = parseInt( props.activeKey, 10 );
        stateChanged = true
      }
    }

    if( props.row !== undefined ) {
      const compare = new Comparison( props.row,state.row);
      if( compare.isMatch( compare.MatchTypes.DataRow ) === false ) {
        newState.row = props.row;
        stateChanged = true;
      }
    }

    if( props.childrow !== undefined ) {
      const compare = new Comparison( props.childrow, state.childrow);
      if( compare.isMatch( compare.MatchTypes.DataRow ) === false ) {
        newState.childrow = props.childrow;
        newState.alert = props.childrow;
        newState.alertMode = 'EDIT';
        newState.activeKey = 1;
        stateChanged = true;
      }
    }

    if( stateChanged === true ) {
      return newState;
    }

    return null;
  }

  onSelectTab( key, content ) {
    if ( this.state.activeKey === key ) {
        return;
    }
    this.setState( {
        activeKey: parseInt( key, 10 ),
        alert: {},
        alertMode: 'LIST'
    }, ( ) => { 
      if( parseInt( this.state.activeKey, 10) === 1 ) {
        this.getAlerts();
      }
    } );
  
  }

  onClose( e ) {
    if( this.props.onClose !== undefined ) {
      this.props.onClose( e );
    }
    this.setState( { 
      activeKey: 0,
    } );
  }
  
  onSave( e ) {
    if( this.props.onSave !== undefined ) {
      e.target.mode = this.state.mode;
      e.target.row = this.state.row;
      this.props.onSave( e );
    }
    this.setState( { 
      activeKey: 0,
    } );
  }

  onChangeRow( e ) {
    let row = this.state.row;
    if( e.target.id === 'ACTIVE' ) {
      if(e.target.checked === true ) {
        row[e.target.id] = 1
      } else {
        row[e.target.id] = 0
      }
    } else {
      row[ e.target.id ] = e.target.value
    }
    this.setState( { 
      row: row
    } );
  }

  onChangeReactiveAt( dateTime ) {
    let alert = this.state.alert;
    alert.REACTIVE_AT = dateTime.format("YYYY-MM-DD HH:mm:ss");
    this.setValue( { 
      alert: alert
    } );
  }

  getAlerts( ) {
    const row = this.state.row;
    console.log('getAlerts() => row', row)
    if( row !== undefined ) {
      if( row.ID !== undefined ) {
        let api = new EtelAPI( 'dipservices/alerts' );
        let parameters = [
          { DIP_SERVICES_ID: parseInt( row.ID, 10 ) } 
        ];
        api.get( parameters ).then( ( result ) => {
          console.log( 'alerts: ', result );
          this.setState( { 
            alerts: result
          } );
        } ).catch( ( ) => { 
          this.setState( { 
            alerts: []
          } );
        } )
      }
    }
  }

  onEditAlertRow( row ) {
    this.setState( { 
      alert: row,
      alertMode: 'EDIT'
    } );
  }

  onDeleteAlertRow( row ) {
    this.setState( { 
      alert: row,
      showDeleteAlertDialog: true
    } );
  }

  onDeleteAlertCancel( e ) {
    this.setState( { 
      showDeleteAlertDialog: false
    } );
  }

  onDeleteAlertConfirm( e ) {
    let alert = this.state.alert;
    let api = new EtelAPI( 'dipservices/alerts' );
    api.delete( alert.ID ).then( ( results ) => { 
      this.setState( { 
        alertMessage: '',
        alert: {},
        alertMode: 'LIST'
      }, ( ) => { 
        if( parseInt( this.state.activeKey, 10) === 1 ) {
          this.getAlerts();
        }
      } );
    } ).catch( ( ) => { 
      this.setState( { 
        alertMessage: 'Could not delete alert!'
      } );
    } )
    this.setState( { 
      showDeleteAlertDialog: false
    } );
  }

  onChangeAlertRow( row ) {
    this.setState( { 
      alert: row
    } ); 
  }

  onNewAlertInput( ) {
    let alert = { 
      "ID": 0,
      "DIP_SERVICES_ID": this.state.row.ID,
      "ALERT_KEY": "",
      "ALERT_VALUE": "",
      "TIMEFRAME_MINUTES": "",
      "OCCURANCE_COUNT": "",
      "LAST_OCCURANCE": "",
      "ALERT_AFTER_COUNT": "",
      "INACTIVE_AFTER_COUNT": "",
      "REACTIVE_AFTER_MINUTES": "",
      "REACTIVE_AT": "",
      "ACTIVE": 1
    };
    this.setState( { 
      alert: alert,
      alertMode: 'NEW'
    } );
  }

  onCancelAlertInput() {
    this.setState( { 
      alert: {},
      alertMode: 'LIST'
    } );
  }

  onSaveAlertInput() {
    let api = new EtelAPI('dipservices/alerts');
    
    if( this.state.alertMode === 'NEW' ) {
      api.insert( this.state.alert ).then( ( result ) => { 
        this.setState( { 
          alert: result[0],
          alertMode: 'LIST',
          alertMessage: ''
        }, ( ) => { 
          if( parseInt( this.state.activeKey, 10) === 1 ) {
            this.getAlerts();
          }                    
        } );
      } ).catch( ( exception ) => {
        console.log( exception );
        this.setState( { 
          alertMessage: 'Failed to create dip service alert.'
        } );
      } );
    }
    
    if(this.state.alertMode === 'EDIT' ) {
      let alert = this.state.alert;
      delete alert["ACTIVE_TEXT"];
      delete alert["SERVICE_NAME"];
      api.update( alert ).then( ( result ) => { 
        this.setState( { 
          alert: result[0],
          alertMode: 'LIST',
          alertMessage: ''
        } );
      } ).catch( ( exception ) => {
        this.setState( { 
          alertMessage: 'Failed to update dip service alert.'
        } );
      } );
    }
  }

  onRenderSettings( ) {
    let checked = this.state.row.ACTIVE === 0 ? false : true;
    return (
        <div className="dip-services-form">
            <div className="dip-services-form-active">
                <input id="ACTIVE" type="checkbox" checked={checked} onChange={this.onChangeRow} />
                <span>Active</span>
            </div>
            <div className="dip-services-form-service-name-label">
                Name
            </div>
            <div className="dip-services-form-service-name-input">
                <input id="SERVICE_NAME" type="text" value={this.state.row.SERVICE_NAME} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-service-description-label">
                Description
            </div>
            <div className="dip-services-form-service-description-input">
                <input id="DESCRIPTION" type="text" value={this.state.row.DESCRIPTION} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-service-code-label">
                Code
            </div>
            <div className="dip-services-form-service-code-input">
                <input id="SERVICE_CODE" type="text" value={this.state.row.SERVICE_CODE} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-alert-email-label">
                Alert E-Mail
            </div>
            <div className="dip-services-form-alert-email-input">
                <input id="ALERT_EMAIL" type="text" value={this.state.row.ALERT_EMAIL} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-alert-test-ani-label">
                Alert Test ANI
            </div>
            <div className="dip-services-form-alert-test-ani-input">
                <input id="ALERT_TEST_ANI" type="text" value={this.state.row.ALERT_TEST_ANI} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-primary-url-label">
                Primary Url
            </div>
            <div className="dip-services-form-primary-url-input">
                <input id="SERVICE_PRIMARY_URL" type="text" value={this.state.row.SERVICE_PRIMARY_URL} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-secondary-url-label">
                Secondary Url
            </div>
            <div className="dip-services-form-secondary-url-input">
              <input id="SERVICE_BACKUP_URL" type="text" value={this.state.row.SERVICE_BACKUP_URL} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-company-code-label">
              Company Code
            </div>
            <div className="dip-services-form-company-code-input">
              <input id="COMPANY_CODE" type="text" value={this.state.row.COMPANY_CODE} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-test-code-label">
              Test Code
            </div>
            <div className="dip-services-form-test-code-input">
              <input id="TEST_CODE" type="text" value={this.state.row.TEST_CODE} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-timeout-label">
              Timeout seconds
            </div>
            <div className="dip-services-form-timeout-input">
                <input id="SERVICE_TIME_OUT_SECONDS" type="text" value={this.state.row.SERVICE_TIME_OUT_SECONDS} onChange={this.onChangeRow} />
            </div>
            <div className="dip-services-form-average-process-time-label">
              Average Process Time
            </div>
            <div className="dip-services-form-average-process-time-input">
              <span>{this.state.row.AVERAGE_PROCESS_TIME}</span> 
            </div>
            <div className="dip-services-form-refresh-in-days-label">
              Refresh in Days
            </div>
            <div className="dip-services-form-refresh-in-days-input">
              <input id="REFRESH_IN_DAYS" type="text" value={this.state.row.REFRESH_IN_DAYS} onChange={this.onChangeRow} />
            </div>
        </div>
    );
  }

  onRenderAlerts() {
    let alertHeader = "";
    let alertContent = "";
    let alertFooter = [];
    if( this.state.alertMode !== 'LIST' ) {
      alertContent = (
        <DipServiceAlertForm 
          row={this.state.alert} 
          mode={this.state.alertMode}
          onChangeRow={this.onChangeAlertRow} 
        />
      );
    } else {
      
      alertHeader = (
        <button className="dialog-save-button" style={{"width":"200px"}} onClick={this.onNewAlertInput}>New Dip Services Alert</button>        
      );

      alertContent = (
        <DipServicesAlertsGrid 
          row={this.state.row}
          alerts={this.state.alerts} 
          onEditRow={this.onEditAlertRow} 
          onDeleteRow={this.onDeleteAlertRow}
        />
      );
    }
    return (
      <div className="dip-services-alerts-form">
        <div className="dip-services-alerts-form-header">
          {alertHeader}
        </div>
        <div className="dip-services-alerts-form-content">
          {alertContent}
        </div>          
        <div className="dip-services-alerts-form-footer">
          {alertFooter}          
        </div>
      </div>
    );
  }

  onRenderBody() {
    let showAlertsTab = this.state.mode === 'EDIT' ? true : false;
    return (
      <DialogBody>
          <ProgramTabContainer onSelectTab={this.onSelectTab} activekey={this.state.activeKey}>
            <ProgramTabPanel>
              <ProgramTabPanelItem caption="Settings" width="100px">
                  {this.onRenderSettings()}
              </ProgramTabPanelItem>
              <ProgramTabPanelItem caption="Alerts" width="100px" visible={showAlertsTab}>
                  {this.onRenderAlerts()}
              </ProgramTabPanelItem>
            </ProgramTabPanel>
          </ProgramTabContainer>
      </DialogBody>
    );
  }

  onRenderFooter() {
    if( parseInt( this.state.activeKey, 10 ) === 0 ) {
      return (
        <DialogFooter>
          <button className="dialog-save-button" onClick={this.onClose}>Cancel</button>
          <button className="dialog-save-button" onClick={this.onSave}>Save</button>
        </DialogFooter>
      );
    } else {
      if( this.state.showDeleteAlertDialog === true ) {
        let row = this.state.alert;
        let deleteMessage = 'Are you sure you want to delete the ' + row.ALERT_KEY  + ' dip service alert?';
        return (
          <DialogFooter>
            <span style={{"color":"red","marginRight":"10px","fontWeight":"bold"}}>
              {deleteMessage}
            </span>
            <button className="dialog-save-button" onClick={this.onDeleteAlertCancel}>Cancel</button>
            <button className="dialog-save-button" onClick={this.onDeleteAlertConfirm}>Confirm</button>
          </DialogFooter>        
        );
      } else {
        const alertMode = this.state.alertMode;
        if( alertMode === 'EDIT' || alertMode === 'NEW' )  {
          return (
            <DialogFooter>
              <span style={{"marginRight":"10px","color":"red","fontWeight":"bold"}}>{this.state.alertMessage}</span>
              <button className="dialog-save-button" onClick={this.onCancelAlertInput}>Cancel</button>
              <button className="dialog-save-button" onClick={this.onSaveAlertInput}>Save</button>
            </DialogFooter>
          );
        } else {
          return (
            <DialogFooter></DialogFooter>        
          );        
        }
      }
    }
  }
  
  render() { 
    let caption = 'Add New Dip Service';
    if( this.state.row.ID !== 0 ) {
      caption  = "Edit Dip Service: " + this.state.row.SERVICE_NAME;
    } 
    return (
      <div>
        <Overlay show={this.props.show} />
        <Dialog show={this.props.show} width={90} height={90}>
          <DialogHeader caption={caption} closeButton onClose={this.onClose} onSave={this.onSave} />
          {this.onRenderBody()}
          {this.onRenderFooter()}
        </Dialog>
      </div>
    )
  }
};


export default DipServiceDialog


// WEBPACK FOOTER //
// ./src/content/technical/dipservices/components/DipServiceDialog.js